<template>
    <v-alert
        density="compact"
        theme="dark"
        color="grey-darken-2"
        class="add-service-snackbar cursor-pointer mb-0 rounded-0 w-100"
        @click="goToOrder"
    >
        <template v-slot:prepend>
            <v-badge v-if="servicesNumber" :offset-x="6" :offset-y="22" color="green" :content="servicesNumber">
                <v-icon>mdi-briefcase-variant-outline</v-icon>
            </v-badge>
            <v-icon v-else class="me-3">mdi-briefcase-variant-outline</v-icon>
            <span :class="{'ms-7': !!servicesNumber}" v-text="`${$t('order')}  #${orderId}`" />
            <v-tooltip v-if="order" location="bottom" color="dark">
                <template v-slot:activator="{props}">
                    <v-icon end size="small" v-bind="props">mdi-information-outline</v-icon>
                </template>
                <div class="py-4">
                    <div
                        v-for="service in order.services"
                        :key="service.serviceId"
                        class="d-flex flex-row align-center mb-1"
                    >
                        <v-icon color="white" class="mr-2 mb-1">
                            {{ serviceTypeIcon(service) }}
                        </v-icon>
                        <span>
                            {{ $filters.dateShortFormat(service.startDateTime) }}
                            {{ service.serviceName }}
                        </span>
                    </div>
                </div>
            </v-tooltip>
        </template>
        <template v-slot:close>
            <v-btn color="white" icon="mdi-close" variant="text" class="close-btn" @click.stop="close" />
        </template>
    </v-alert>
</template>

<script lang="ts">
    import {Component, Vue, Watch} from 'vue-facing-decorator'
    import {getServiceTypeIcon} from '~src/utils/helpers'
    import hotels from '@/routes/hotels'
    import transfers from '@/routes/transfers'
    import activities from '@/routes/activities'
    import flights from '@/routes/flights'
    import packages from '@/routes/packages'
    import tours from '@/routes/tours'
    import extraServices from '@/routes/extraServices'
    import carsRent from '@/routes/carsRent'
    import cruises from '@/routes/cruises'
    import insurance from '@/routes/insurance'

    @Component
    export class AddServiceSnackbar extends Vue {
        @Watch('$route', {immediate: true})
        onRouteChange(to) {
            if (!this.allowedRouteNames.includes(to.name)) {
                this.clear()
            }
        }

        async mounted() {
            await this.$store.restored
            if (this.orderId && this.servicesNumber === undefined) {
                await runtimeStore.loadOrder({
                    orderType: authStore.orderType,
                    orderId: this.orderId,
                })
            }
        }

        goToOrder() {
            if (this.isDriver || this.isGuide) {
                this.$router.push({name: 'scheduler'})
            } else {
                this.$router.push({name: 'order-details', params: {id: this.orderId}})
            }
        }

        close() {
            this.goToOrder()
            this.clear()
        }

        clear() {
            persistentStore.SET_SELECTED_ORDER_ID(null)
        }

        serviceTypeIcon(service) {
            return getServiceTypeIcon(service)
        }

        get orderId() {
            return persistentStore.selectedOrderId
        }

        get order() {
            return runtimeStore.orderDetails
        }

        get servicesNumber() {
            return this.order?.services?.length
        }

        get isGuide() {
            return authStore.isGuide
        }

        get isDriver() {
            return authStore.isDriver
        }

        get allowedRouteNames() {
            const allowedRouteNames = ['home', 'orders', 'order-details']
            const productBookingFlowRouteNames = [
                ...hotels,
                ...transfers,
                ...activities,
                ...flights,
                ...packages,
                ...tours,
                ...extraServices,
                ...carsRent,
                ...cruises,
                ...insurance,
            ].map(el => el.name)
            return [...allowedRouteNames, ...productBookingFlowRouteNames]
        }
    }

    export default AddServiceSnackbar
</script>
